module.exports = __webpack_public_path__ + "img/no-payment.d3a80530.svg";